var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hedaers'),_c('router-view',{key:_vm.key,staticStyle:{"padding-bottom":"506px"}}),_c('Bottoms')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }